import PortfolioImage from "../../../../../assets/images/png/courses/portfolio/product.webp";
import {
  default as CoachImage,
  default as TestimonialImg,
} from "../../../../../assets/images/png/user.svg";
import TestimonialImage from "../../../../../assets/images/png/user.webp";
import AlunmiImage from "../../../../../assets/images/svg/incubation.svg";
import LearnImage from "../../../../../assets/images/svg/intensive-learning.svg";
import BuildingImage from "../../../../../assets/images/svg/internship.svg";
import SupportImage from "../../../../../assets/images/svg/people-primary.svg";

export const hrAnalyticsData = {
  tag: "For HR Professionals",
  title: "Agile HR Analytics",
  seoTitle: "HR Analytics Course Online Nigeria | Utiva",
  description: `The Agile HR Analytics program is designed for HR
  professionals(junior and senior) to help bring the value of Big
  Data Analytics to HR functions and Talent Management.`,
  metatags: `Learn to make data-driven HR decisions. Master workforce analytics, people data, and HR dashboards in Utiva's practical HR Analytics course. Enrol online today.`,
  duration: "3 months",

  downloadBrochureUrl:
    "https://drive.google.com/file/d/167YZJIDnFvNkbjx3llI2L-1thJqKnkDo/view?usp=sharing",

  courseFormUrl: "courses/hr-analytics/fill-form",

  jobTitle: "HR Analytics",

  kickoffDate: "December 2",
  kickoffTime: (
    <>
      Saturday 10:00 AM - 1:00 PM WAT
      <br />
      Sunday 2:00 PM - 5:00 PM WAT
    </>
  ),

  testimonial: {
    image: TestimonialImage,
    name: "Ridwan Gbolagade",
    role: "Allan & Grant Consulting Firm",
    testimony: `
    Typically, they say that data is the future but now it's not
      the future but what is happening right now. Utiva Agile HR Analytics program
      taught me how I can make values from a chunk of data and coin the numbers to
      make informed decisions, which aids
      HR strategic functions in deals like Recruitment, Learning and Development etc.`,
    starRating: "5.0",
  },

  courseOverview: {
    title: `The HR Analytics training program is designed to give learners the required skills, 
    knowledge and leveraged needed to becomes human resource analyst in any industry. `,
    desc: `
    Taught by industry leaders, the course uses a project-based learning model, 
    ensuring professionals gain hands-on experience creating digital products 
    with the user firmly in mind. Your best course for career transformation 
    in HR. This full-time HR Analytics program features expert instruction, 
    one-on-one career coaching, and connections to top employers to get you hired.
    `,
  },
  courseOutlines: [
    {
      unitId: 1,
      unitTitle: "Data Processing",
      unitTag: "Data",
      unitDescription: `
      Sorting and filtering, building formulas, using Paste Special and Pivot Tables, IF function, cell references, linking worksheets, summarising data using Subtotal, Excel charts.
        `,
      unitFeatures: [],
    },
    {
      unitId: 2,
      unitTitle: "Data Analysis",
      unitTag: "Data",
      unitDescription: `
      Learn how to use time-saving keyboard shortcuts, convert and clean data types including text, times and dates, build impressive logic functions and conditional aggregations.
        `,
      unitFeatures: [],
    },
    {
      unitId: 3,
      unitTitle: "Data Modelling",
      unitTag: "Data",
      unitDescription: `
      Building models for data by creating relationships among the data sources. Integrating the tables, enabling extensive analysis using PivotTables, Power Pivot, and Power View.
        `,
      unitFeatures: [],
    },
    {
      unitId: 4,
      unitTitle: "Data Segmentation",
      unitTag: "Data",
      unitDescription: `
     How to break down or combine data into meaningful groups, and then comparing those groups to identify meaningful relationships in your data and how it is applied.
        `,
      unitFeatures: [],
    },
    {
      unitId: 5,
      unitTitle: "Data Visualization",
      unitTag: "Data",
      unitDescription: `
    How to interact with data to find business insights and intelligence. Using Microsoft PowerBI custom visuals, or selecting from lists of available visuals in building dashboards.
        `,
      unitFeatures: [],
    },
  ],

  courseCoaches: [
    {
      coachId: 1,
      coachImage: CoachImage,
      coachName: "Eyitayo Ogunmola",
      coachRole: "Data Analyst",
    },
  ],

  learningModels: [
    {
      modelId: 1,
      modelIcon: LearnImage,
      modelTitle: "Learning Model",
      modelDescription:
        "A 6 Weeks experiential learning and hands-on training session.",
    },
    {
      modelId: 2,
      modelIcon: SupportImage,
      modelTitle: "Training Methodology",
      modelDescription: "Learn through real-life problems",
    },
    {
      modelId: 3,
      modelIcon: BuildingImage,
      modelTitle: "Business Case-Focused",
      modelDescription:
        "Work on real-life projects by applying what you learn to solve related business problems.",
    },
    {
      modelId: 4,
      modelIcon: AlunmiImage,
      modelTitle: "Access Contents & Materials",
      modelDescription: "50% on your own + 50% in live classes",
    },
  ],

  studentTestimonies: [
    {
      id: 1,
      linkedIn: "",
      image: TestimonialImg,
      firstname: "Ridwan",
      lastname: "Gbolagade",
      company: "Allan & Grant Consulting Firm",
      testimony: `Typically, they say that data is the future but now it's not
      the future but what is happening right now. Utiva Agile HR Analytics program
      taught me how I can make values from a chunk of data and coin the numbers to
      make informed decisions, which aids
      HR strategic functions in deals like Recruitment, Learning and Development etc.`,
    },
    {
      id: 2,
      linkedIn: "",
      image: TestimonialImg,
      firstname: "Maureen",
      lastname: "Iyasele-bello",
      company: "Human Resources Management",
      testimony: `My advice to fellow HR practitioners is to
      become more strategic in nature, base your decisions on data,
      because like they say, “Data do not lie”. So I would definitely
      advise that you embark on the agile HR analytics class with Utiva,
      so that you can hone in on your skills. You can learn
      how to take raw data and interpret that data to make better decisions.`,
    },
    {
      id: 3,
      linkedIn: "",
      image: TestimonialImg,
      firstname: "Toyin",
      lastname: "Sanni",
      company: "Human Resources Professional",
      testimony: `If you can get so much value for a sponsored course,
      then when people come for a paid course and I am enrolling with
      Utiva for a paid course, I can imagine what benefits or values I
      would get, the agile HR analytics is a very great program put together by Utiva.
      I would not only recommend HR analytics, I would recommend Utiva to my colleagues.`,
    },
  ],

  portofolio: {
    title: "Build and Showcase Your HR Analytics Portfolio",
    description: `
    To earn your HR Analytics certification, showcase everything you've 
    learned in a pitch presentation where experts evaluate your 
    new HR Analytics skillset.
      `,

    name: "Olatunji Abayomi",
    // image: PortfolioUserAvatar,
    portfolioImage: PortfolioImage,
  },

  certification: {
    title: "Earn a Utiva HR Analytics Certification",
    description: `
    Upon completing Utiva's HR Analytics Course, you'll receive an 
    industry-recognized, professional HR Analytics certification to 
    share with your network and showcase all that you've learned. 
    Utiva certificates are formatted for sharing on LinkedIn.
      `,
  },

  videoTestimonial: "https://www.youtube.com/embed/EwYGCtYJr-0",

  otherCourses: [
    {
      id: 1,
      courseTitle: "Product Accelerator",
      courseDescription: `This training is designed by top professionals to help you fast-track 
      your career in Product Management. Designed for those that already 
      have their foot in the industry and want to fast-track their career.`,
      courseUrl: "/courses/product-management-and-design-bootcamp",
    },
  ],
};
